export default {
	"foreaccountroad": {
		"settlementStatus": "t结算状态"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/foreaccount/foreaccount.js